import React from "react";
import '../css/Projetos.css';
import project1 from '../img/frontendCaptura.png';
import project2 from '../img/project2.png';
import project3 from '../img/project3.png';

function Projetos() {
  return (
    <div className="project component__space" id="Projetos">
      <div className="heading">
        <h1 className="heading">Projetos</h1>
        <p className="heading p__color">
        Aqui estão alguns dos meus projetos Front-end desenvolvidos para fins acadêmicos. 
        </p>
        <p className="heading p__color">
        </p>
      </div>
      <div className="container">
        <div className="row">

          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={project1} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                {/* <h5 className="project__text">Development</h5> */}
                <h4 className="project__text">Front End Online Store</h4>
                <a href="https://github.com/henriquejbraga/fronend-online-store" className="project__btn">Repositório</a>
              </div>
            </div>
          </div>

          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={project2} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                {/* <h5 className="project__text">Development</h5> */}
                <h4 className="project__text">Calculadora Online</h4>
                <a href="https://calculadorareacthenrique.netlify.app/" className="project__btn">WebSite</a>
              </div>
            </div>
          </div>

          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={project3} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                {/* <h5 className="project__text">Development</h5> */}
                <h4 className="project__text">App de Receitas</h4>
                <a href="https://github.com/henriquejbraga/App-receitas" className="project__btn">Repositório</a>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  )
}

export default Projetos